import React from 'react';
import { motion } from 'framer-motion';
import cvData from '../../data/cv';
import { TechPills } from './TechPill';
import { SectionHeading } from './ExperienceTimeline';
export function Capabilities() {
  const {
    skills,
    meta
  } = cvData;
  return <section id="skills" className="mx-auto max-w-6xl px-6 py-20 md:px-12" data-id="element-212" data-mp="o6yfniydbaqw">
      <SectionHeading index={meta.sections.capabilities.index} title={meta.sections.capabilities.title} data-id="element-213" data-mp="s7idkoqrmie3" />
      <div className="mt-12 grid gap-x-12 gap-y-10 md:grid-cols-2" data-id="element-214" data-mp="1fu6yzkezgszg">
        {skills.map((group, i) => <motion.div key={group.label} initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        delay: i % 2 * 0.08
      }} data-id="element-215" data-mp="1kt0etjhqsw2s" data-mpi={i}>
            <p className="mb-3 font-mono text-[11px] uppercase tracking-[0.22em] text-[var(--accent)]" data-id="element-216" data-mp="33wtc6hlfov1i">
              {group.label}
            </p>
            <TechPills labels={group.items} data-id="element-217" data-mp="2z0mfzgiuaxwr" />
          </motion.div>)}
      </div>
    </section>;
}